import {NgModule} from '@angular/core';
import {RouterModule, Routes, UrlMatchResult, UrlSegment} from '@angular/router';
import {NetscopeDashboardComponent} from "@app/netscope/netscope-dashboard/netscope-dashboard.component";
import {NetscopeTopologyComponent} from "@app/netscope/netscope-topology/netscope-topology.component";
import {NetscopeHeatmapViewerComponent} from "@app/netscope/netscope-heatmap-viewer/netscope-heatmap-viewer.component";
import {
  NetscopeCustomProtocolsComponent
} from "@app/netscope/netscope-custom-protocols/netscope-custom-protocols.component";
import {
  NetscopeCommonFlowviewComponent
} from "@app/netscope/netscope-common-flowview/netscope-common-flowview.component";
import {NetscopeExternalIpsComponent} from "@app/netscope/netscope-external-ips/netscope-external-ips.component";
import {NetscopeDiagnosticComponent} from "@app/netscope/netscope-diagnostic/netscope-diagnostic.component";
import {
  NetscopeThreatCenterComponent
} from "@app/netscope/netscope-threat-center/netscope-threat-center.component";
import {AuthGuard} from "@app/helper/auth.guard";
import {NetscopeReportsComponent} from "@app/netscope/netscope-reports/netscope-reports.component";
import {NetscopeOutsideFlowsComponent} from "@app/netscope/netscope-outside-flows/netscope-outside-flows.component";
import {
  NetscopeFlowsDescriptionsComponent
} from "@app/netscope/netscope-flows-descriptions/netscope-flows-descriptions.component";
import {
  FortinetDashboardComponent
} from "@app/fortinet/fortinet-dashboard.component";
import {
  NetscopeAppsGroupsViewerComponent
} from "@app/netscope/netscope-apps-groups-viewer/netscope-apps-groups-viewer.component";

/**
 * Pages of the apps groups page: 'apps-groups', then optionally a file, what is shown of it ('view', 'edit' or
 * 'flows') and, when editing, a group of it. A single route for all of them, so that the page stays the same
 * component, and its unsaved changes with it, as the user moves between them.
 */
export function appsGroupsUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length == 0 || segments[0].path != 'apps-groups' || segments.length > 4) {
    return null;
  }
  let posParams: { [name: string]: UrlSegment } = {};
  ['file', 'mode', 'group'].forEach((name, index) => {
    if (segments[index + 1] != undefined) {
      posParams[name] = segments[index + 1];
    }
  });
  return {consumed: segments, posParams: posParams};
}

const routes: Routes = [
  {
    path: "",
    redirectTo: "/dashboard",
    pathMatch: "full",
  },
  {
    path: 'dashboard',
    component: NetscopeDashboardComponent,
    canActivate: [AuthGuard]
  }, {
    path: '',
    component: NetscopeDashboardComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'topology',
    component: NetscopeTopologyComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'heatmap-viewer',
    component: NetscopeHeatmapViewerComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'heatmap-viewer/:resource_uuid_1/:resource_uuid_2',
    component: NetscopeHeatmapViewerComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'custom-protocols',
    component: NetscopeCustomProtocolsComponent,
    canActivate: [AuthGuard]
  }, {
    // The apps groups page replaced the apps groups view of the flows view: its addresses lead to the page
    path: 'flows/apps-groups',
    redirectTo: 'apps-groups',
    pathMatch: 'full'
  }, {
    path: 'flows/apps-groups/apps_groups/:apps_groups',
    redirectTo: 'apps-groups',
    pathMatch: 'full'
  }, {
    path: 'flows/:selected_view',
    component: NetscopeCommonFlowviewComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'flows/:selected_view/apps_groups/:apps_groups',
    component: NetscopeCommonFlowviewComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'flows/:selected_view/protocols/:protocols',
    component: NetscopeCommonFlowviewComponent,
    canActivate: [AuthGuard]
  }, {
    // Apps groups page
    matcher: appsGroupsUrlMatcher,
    component: NetscopeAppsGroupsViewerComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'external_ips',
    component: NetscopeExternalIpsComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'diagnostic',
    component: NetscopeDiagnosticComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'reports',
    component: NetscopeReportsComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'outside',
    component: NetscopeOutsideFlowsComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'threat_center',
    component: NetscopeThreatCenterComponent,
    canActivate: [AuthGuard]
  },{
    path: 'nis2',
    component: NetscopeFlowsDescriptionsComponent,
    canActivate: [AuthGuard]
  },{
    path: 'fortinet',
    component: FortinetDashboardComponent,
    canActivate: [AuthGuard]
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
